import React from 'react';
import { Loader2, PenLine } from 'lucide-react';
import { dataIt } from '../../haccpApi';
import { DpiManuali } from './DpiManuali';

const STATI = {
  da_creare: ['Da creare', 'bg-sky-100 text-sky-800'], da_firmare: ['Da firmare', 'bg-amber-100 text-amber-800'],
  firmato: ['Firmato', 'bg-emerald-100 text-emerald-800'], senza_dpi: ['DPI da aggiungere', 'bg-amber-100 text-amber-800'],
  senza_mansione: ['Mansione mancante', 'bg-red-100 text-red-800'], datore: ['Datore di lavoro', 'bg-gray-100 text-gray-700'],
  da_leggere: ['Da leggere', 'bg-gray-100 text-gray-600'],
};
const titolo = (s) => (s || '').toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

const Nota = ({ r, testid, onSalvato }) => {
  if (r.stato === 'senza_dpi' || (r.stato === 'da_creare' && r.fonte === 'manuale')) {
    return (
      <div className="w-full space-y-1.5">
        {r.stato === 'senza_dpi' && <p className="text-xs text-amber-800 bg-amber-50 rounded-lg px-2.5 py-1.5" data-testid={`${testid}-avviso-dpi`}>Il DVR non indica DPI per la mansione {r.mansione.toLowerCase()}: scrivili tu.</p>}
        <DpiManuali mansione={r.mansione} iniziali={r.fonte === 'manuale' ? r.dpi : null} testid={testid} onSalvato={onSalvato} />
      </div>
    );
  }
  const testo = { senza_mansione: 'Nessun attestato riporta la mansione: carica un attestato dove è scritta.', datore: 'Non serve il verbale: è chi consegna i DPI.' }[r.stato];
  return testo ? <p className="text-xs text-gray-600" data-testid={`${testid}-nota`}>{testo}</p> : null;
};

export const LavoratoreDpi = ({ r, busy, onCrea, onFirma, onSalvato }) => {
  const testid = `dpi-lavoratore-${r.persona_id.replace(/[^a-zA-Z0-9-]/g, '-')}`;
  const [etichetta, stile] = STATI[r.stato] || STATI.da_leggere;
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3 space-y-2" data-testid={testid}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-gray-900">{r.nome}</p>
          <p className="text-[11px] text-gray-500" data-testid={`${testid}-mansione`}>{r.mansione ? titolo(r.mansione) : r.stato === 'datore' ? '' : 'Mansione non trovata'}{r.data_consegna ? ` · consegna del ${dataIt(r.data_consegna)}` : ''}</p>
        </div>
        <span className={`shrink-0 px-2 py-0.5 rounded-full text-[11px] font-bold ${stile}`} data-testid={`${testid}-stato`}>{etichetta}</span>
      </div>
      {r.dpi?.length > 0 && (
        <div className="flex flex-wrap gap-1" data-testid={`${testid}-dpi`}>
          {r.dpi.map((d) => <span key={d.nome} className="px-2 py-0.5 rounded-full bg-gray-100 text-[11px] text-gray-700">{d.nome}</span>)}
          {r.fonte === 'manuale' && <span className="px-2 py-0.5 text-[11px] text-orange-700">scritti da te</span>}
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        <Nota r={r} testid={testid} onSalvato={onSalvato} />
        {r.stato === 'da_creare' && (
          <button onClick={() => onCrea([r.persona_id])} disabled={busy} className="h-9 px-3 rounded-lg bg-sky-700 text-white text-xs font-semibold flex items-center gap-1 disabled:opacity-60" data-testid={`${testid}-crea`}>
            {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Crea verbale
          </button>
        )}
        {r.stato === 'da_firmare' && (
          <button onClick={() => onFirma(r.documento_id)} className="h-9 px-3 rounded-lg bg-amber-500 text-white text-xs font-semibold flex items-center gap-1" data-testid={`${testid}-firma`}>
            <PenLine className="h-3.5 w-3.5" />Firma
          </button>
        )}
      </div>
    </div>
  );
};
